module.exports = __webpack_public_path__ + "static/img/47.591229d4.png";